var map = {
	"./ar.json": [
		75235,
		235
	],
	"./en.json": [
		48083,
		83
	],
	"./es.json": [
		81000,
		0
	],
	"./fr.json": [
		28464,
		464
	],
	"./hi.json": [
		16403,
		403
	],
	"./ml.json": [
		97081,
		81
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57146;
module.exports = webpackAsyncContext;